export const API_URLS = {
	MEDIA: {
		CREATE: "/media/create"
	}
};
